import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";
import * as React from "react";

import { ReferentialItemDto } from "../../api";
import { useCategoryRef, useCommonHooks } from "../../hooks";
import { ETLCodes } from "../../locales";
import { nameof } from "../../utils";

export interface ICategorySelectProps extends IFGSelectInputProps<any> {
  name: string;
  label?: string;
}

export const CategorySelect: React.FunctionComponent<ICategorySelectProps> = ({
  name,
  label,
  ...fgSelectInputProps
}) => {
  const { t } = useCommonHooks();
  const { categories, categoriesLoading } = useCategoryRef();

  return (
    <FGSelectInput
      noLabel={!label}
      label={label}
      name={name}
      items={categories}
      loading={categoriesLoading}
      displayField={nameof<ReferentialItemDto>("displayValue")}
      valueField={nameof<ReferentialItemDto>("idValue")}
      isFilterable={true}
      {...fgSelectInputProps}
    />
  );
};
